export class SceneStatus
{
    constructor(json: object = null)
    {
        if (json)
        {
            Object.assign(this, json);

            this.setParameters(json);
        }
    }

    public CurrentSceneTime: Date;
    public IsGatewayOnline: boolean;
    public IsSceneForcedOff: boolean;
    public IsSceneForcedOn: boolean;
    public IsSceneOffDueToForceOnExpiration: boolean;
    public IsSceneOn: boolean;
    public IsSceneScheduledOn: boolean;
    public LastGatewayCommunication: Date;
    public LastSceneForceOffTime: Date;
    public LastSceneForceOnTime: Date;
    public LastScheduledOffTime: Date;
    public LastScheduledOnTime: Date;
    public NextScheduledOffTime: Date;
    public NextScheduledOnTime: Date;
    public SceneDstOffset: number;
    public SceneId: number;
    public TroubleshootingInfo: string;
    public WhenSceneForceReleased: Date;
    public StatusText: string;
    public NextStatusText: string;

    private setParameters(json: object)
    {
        this.CurrentSceneTime = new Date(json['CurrentSceneTime']);
        this.LastGatewayCommunication = new Date(json['LastGatewayCommunication']);
        this.LastSceneForceOffTime = new Date(json['LastSceneForceOffTime']);
        this.LastSceneForceOnTime = new Date(json['LastSceneForceOnTime']);
        this.LastScheduledOffTime = new Date(json['LastScheduledOffTime']);
        this.LastScheduledOnTime = new Date(json['LastScheduledOnTime']);
        this.NextScheduledOffTime = new Date(json['NextScheduledOffTime']);
        this.NextScheduledOnTime = new Date(json['NextScheduledOnTime']);
        this.WhenSceneForceReleased = new Date(json['WhenSceneForceReleased']);
    }
}
